import imageCompression from 'browser-image-compression';
import EXIF from 'exif-js';

export function convertToBase64WithCanvas(file, isMobile = true) {
  const ua = window.navigator.userAgent.toLocaleLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(ua);
  if (!isIOS ||!isMobile) {
    return { file };
  }

  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // 设置Canvas尺寸与图片一致
      canvas.width = img.width;
      canvas.height = img.height;

      // 绘制图片到Canvas
      ctx.drawImage(img, 0, 0);

      // 生成高质量JPEG的Base64
      const base64 = canvas.toDataURL('image/jpeg', 0.9);

      // 转换回File对象
      canvas.toBlob((blob) => {
        const processedFile = new File([blob], file.name, {
          type: 'image/jpeg',
          lastModified: Date.now()
        });

        resolve({
          file: processedFile,
        });
        URL.revokeObjectURL(url);
      }, 'image/jpeg', 0.9);
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('图片加载失败'));
    };

    img.src = url;
  });
}

// 压缩图片
export async function compressImage(file, options = {}) {
  if (/\.(jpeg|png|bmp|webp)$/.test(file.name)) {
    const defaultOptions = {
      maxSizeMB: 20,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
      fileType: 'image/jpeg'
    };

    const mergedOptions = { ...defaultOptions, ...options };

    try {
      const compressedBlob = await imageCompression(file, mergedOptions);
      // 将压缩后的 Blob 转换为 File 对象,保持原始文件名
      const compressedFile = new File([compressedBlob], file.name, {
        type: compressedBlob.type,
        lastModified: Date.now()
      });
      return compressedFile;
    } catch (error) {
      console.error('[compressImage] 压缩失败:', error);
      throw new Error(`图片压缩失败，请尝试其他图片: ${error}`);
    }
  } else {
    return file;
  }
}
